import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../modules/authentication/authentication.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { PAGES } from '../../constants/route.constants';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
})
export class LogoutComponent implements OnInit {
  public loginInProgress: boolean = false;
  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    private activatedRouteRef: ActivatedRoute,
    private authService: AuthenticationService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.activatedRouteRef.queryParams.subscribe(
      (params: { status?: string }) => {
        if (params?.status === 'in-progress') {
          this.loginInProgress = true;
        }
      },
    );
    this.authService.isLoggedIn
      .pipe(takeUntil(this.destroy$))
      .subscribe((isLoggedIn) => {
        if (isLoggedIn) {
          this.router.navigate([PAGES.LANDING]);
        }
      });
  }

  login() {
    this.authService.login();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
